<template>
  <div class="tb-page">
    <div class="tb-note">
      Los datos de GPS son <b>simulados</b>: las posiciones se calculan en el navegador y persisten en
      <b>LocalStorage</b>, por lo que los buses «avanzan» aunque cierres la app. Esto simula el flujo real:
      app del conductor → backend → mapa.
    </div>

    <ion-button expand="block" @click="reiniciar">
      <ion-icon :icon="refreshOutline" slot="start" />Reiniciar simulación
    </ion-button>
    <ion-button expand="block" fill="outline" @click="exportar">
      <ion-icon :icon="downloadOutline" slot="start" />Exportar posiciones (JSON)
    </ion-button>

    <pre class="tb-json">{{ estadoJson }}</pre>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { IonButton, IonIcon } from '@ionic/vue';
import { refreshOutline, downloadOutline } from 'ionicons/icons';
import { sim } from '../stores/simulation';
import { pointAt } from '../data/mock';

const estadoJson = computed(() => {
  const o = { actualizado: new Date().toLocaleString(), rutas: {} };
  sim.routes.forEach(r => {
    if (!r.cum) { o.rutas[r.id] = []; return; }
    o.rutas[r.id] = r.buses.map(b => {
      const p = pointAt(r.path, r.cum, b.dist);
      return { placa: b.placa, lat: +p.coord[1].toFixed(6), lon: +p.coord[0].toFixed(6), kmh: b.vel || b.speed };
    });
  });
  return JSON.stringify(o, null, 2);
});

function reiniciar() {
  localStorage.removeItem('tubus_mock_v1');
  location.reload();
}

function exportar() {
  const o = { ts: new Date().toISOString(), buses: [] };
  sim.routes.forEach(r => r.buses.forEach(b => {
    const p = pointAt(r.path, r.cum, b.dist);
    o.buses.push({
      ruta: r.id, placa: b.placa,
      lat: +p.coord[1].toFixed(6), lon: +p.coord[0].toFixed(6),
      kmh: b.vel || b.speed
    });
  }));
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([JSON.stringify(o, null, 2)], { type: 'application/json' }));
  a.download = 'tubus_posiciones.json';
  a.click();
}
</script>

<style scoped>
.tb-page {
  padding: 14px; max-width: 640px; margin: 0 auto;
  display: flex; flex-direction: column; gap: 12px;
  flex: 1 1 auto; overflow-y: auto; width: 100%;
}
.tb-note {
  background: #fff; border-left: 4px solid var(--tb-blue); border-radius: 10px;
  padding: 12px 14px; font-size: 13px; color: var(--tb-muted);
  box-shadow: 0 3px 10px rgba(20, 26, 94, .06);
}
.tb-json {
  background: #0E133F; color: #9BE7A8; border-radius: 12px; padding: 12px;
  font-size: 11px; overflow: auto; max-height: 300px; margin: 0;
}
ion-button { --border-radius: 12px; font-weight: 600; }
</style>
